import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Layers, LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { errorMessage } from "@/lib/api";
import { LOGIN } from "@/constants/testIds";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || "/";

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      const msg = errorMessage(err, "Email ou password incorretos.");
      toast.error("Não foi possível entrar", { description: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-background text-foreground p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 justify-center mb-8">
          <div className="w-8 h-8 bg-foreground flex items-center justify-center">
            <Layers className="w-4 h-4 text-background" />
          </div>
          <div className="leading-none text-center">
            <h1 className="font-head text-sm font-bold tracking-tight">LOMARTEX · MOLDES EXPORTER</h1>
            <p className="text-[10px] text-muted-foreground mono mt-0.5">Iniciar sessão</p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="border border-border bg-card p-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="login-email">Email</Label>
            <Input
              id="login-email"
              data-testid={LOGIN.emailInput}
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@empresa.pt"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="login-password">Password</Label>
            <Input
              id="login-password"
              data-testid={LOGIN.passwordInput}
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <Button
            type="submit"
            data-testid={LOGIN.submitButton}
            disabled={loading}
            className="w-full rounded-[4px]"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Entrar
          </Button>
        </form>

        <p className="text-xs text-muted-foreground/70 text-center mt-4">
          Sem acesso público — contas criadas pelo administrador.
        </p>
      </div>
    </div>
  );
}
